import { render, staticRenderFns } from "./CreateReferralNodeForm.vue?vue&type=template&id=5f07a521&"
import script from "./CreateReferralNodeForm.vue?vue&type=script&lang=ts&"
export * from "./CreateReferralNodeForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateReferralNodeForm.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports